angular
    .module('empower.control')
    .directive("pageurl", function () {
        return {
            restrict: "E",
            templateUrl: function (elem, attrs) {
                return "views/" + attrs.templateurl || "";
            }
        };
    })
    .directive("pageurl2", function () {
        return {
            restrict: "E",
            templateUrl: function (elem, attrs) {
                return attrs.templateurl || "";
            }
        };
    })
    .directive('dynamicUrl', ['$http', '$templateCache', '$compile', '$parse', function($http, $templateCache, $compile, $parse) {
        return {
            restrict: 'E',
            replace: true,
            template: '<div ng-include="contentUrl"></div>',
            link: function(scope , iElement, iAttrs) {                            
                scope.contentUrl = '';
                iAttrs.$observe("url", function (url){
                    scope.contentUrl = url;
                });
            } 
        }
    }]);
